import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import messages from "../../../../../../../assets/locale/messages";
import RejectReasonModal from "../../../../../../../components/modals/RejectReasonModal";
import ReviewChangesSummary from "./ReviewChangesSummary";
import ReviewDocumentChanges from "./ReviewDocumentChanges";
import ReviewDiffSection from "./ReviewDiffSection";
import ReviewProfileActions from "./ReviewProfileActions";
import { buildEditRequestDiff } from "../../../../../../../utils/buildEditRequestDiff";

const ReviewProfileDiffPanel = ({
  editDetail,
  lang,
  registrationReq,
  cl,
  patchSubmitting,
  onApprove,
  onRejectSubmit,
}) => {
  const [rejectOpen, setRejectOpen] = useState(false);

  const { companyFields, contactFields, documentFields, changeCount } = useMemo(
    () => buildEditRequestDiff(editDetail, lang, registrationReq, cl),
    [editDetail, lang, registrationReq, cl],
  );

  const { shared } = messages[lang];

  return (
    <>
      <ReviewProfileActions
        onReject={() => setRejectOpen(true)}
        onApprove={onApprove}
        rejectLabel={cl.rejectUpdateRequest}
        approveLabel={cl.approveUpdate}
        disabled={patchSubmitting}
      />
      <div className="company-view-layout mt-3">
        <div className="company-view-main">
          <ReviewDiffSection
            variant="company"
            title={registrationReq.companyInformation}
            fields={companyFields}
          />
          <ReviewDiffSection
            variant="contact"
            title={registrationReq.contactPerson}
            fields={contactFields}
          />
          <ReviewDocumentChanges
            title={registrationReq.documents}
            fields={documentFields}
            cl={cl}
          />
        </div>
        <aside className="company-view-aside">
          <ReviewChangesSummary changeCount={changeCount} cl={cl} />
        </aside>
      </div>

      <RejectReasonModal
        open={rejectOpen}
        submitting={patchSubmitting}
        onClose={() => setRejectOpen(false)}
        onConfirm={(reason) => onRejectSubmit(reason)}
        title={cl.rejectEditRequestModalTitle}
        description={cl.rejectEditRequestModalDescription}
        reasonLabel={cl.rejectEditRequestReasonLabel}
        reasonPlaceholder={cl.rejectEditRequestReasonPlaceholder}
        confirmLabel={cl.confirmRejectEditRequest}
        cancelLabel={shared.cancel}
        minReasonLength={3}
        requiredErrorMessage={registrationReq.required}
        minLengthErrorMessage={registrationReq.rejectionReasonMinLength}
        reasonInputId="reject-profile-edit-reason"
      />
    </>
  );
};

ReviewProfileDiffPanel.propTypes = {
  editDetail: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  registrationReq: PropTypes.object.isRequired,
  cl: PropTypes.object.isRequired,
  patchSubmitting: PropTypes.bool,
  onApprove: PropTypes.func.isRequired,
  onRejectSubmit: PropTypes.func.isRequired,
};

ReviewProfileDiffPanel.defaultProps = {
  patchSubmitting: false,
};

export default ReviewProfileDiffPanel;
